import * as React from "react";
import { cn } from "@/lib/utils";

interface SpotlightCardProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  className?: string;
  /** Kept for backward compatibility; no longer has any effect */
  disableSpotlight?: boolean;
  as?: React.ElementType;
}

/**
 * SpotlightCard
 *
 * A neutral card wrapper with subtle hover elevation.
 */
export function SpotlightCard({
  children,
  className,
  disableSpotlight: _disableSpotlight,
  as: Component = "div",
  ...props
}: SpotlightCardProps) {
  return (
    <Component
      className={cn(
        "rounded-2xl border border-border bg-card shadow-sm transition-shadow hover:shadow-md",
        className,
      )}
      {...props}
    >
      {children}
    </Component>
  );
}

/**
 * SpotlightCardContent
 *
 * Standard content wrapper for SpotlightCard.
 */
export function SpotlightCardContent({
  children,
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={cn("p-6", className)} {...props}>
      {children}
    </div>
  );
}
